import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Capacitor } from '@capacitor/core';
import { Network } from '@capacitor/network';

@Injectable({
  providedIn: 'root'
})
export class NetworkErrorService {
  private hasErrorSubject = new BehaviorSubject<boolean>(false);
  public hasError$ = this.hasErrorSubject.asObservable();

  /** İnternet geri geldiğinde tek seferlik sinyal atar. Native only. */
  public networkRestored$ = new Subject<void>();

  constructor(private zone: NgZone) {}

  showError() {
    this.zone.run(() => this.hasErrorSubject.next(true));
  }

  hideError() {
    this.zone.run(() => this.hasErrorSubject.next(false));
  }

  /**
   * Proaktif ağ dinlemeyi başlatır (sadece native/mobil platformda).
   * AppComponent.ngOnInit() tarafından çağrılır.
   * - Açılışta mevcut durumu kontrol eder
   * - Bağlantı değişikliklerini anlık dinler
   * - İnternet gelince banner'ı otomatik kapatır
   */
  initialize(): void {
    if (!Capacitor.isNativePlatform()) return;

    // Açılışta mevcut ağ durumunu kontrol et
    Network.getStatus().then(status => {
      this.zone.run(() => {
        if (!status.connected) {
          this.hasErrorSubject.next(true);
        }
      });
    });

    // Bağlantı değişikliklerini dinle
    Network.addListener('networkStatusChange', (status) => {
      this.zone.run(() => {
        if (!status.connected) {
          this.hasErrorSubject.next(true);
        } else {
          this.hasErrorSubject.next(false);
          this.networkRestored$.next();
        }
      });
    });
  }
}
